import React from "react";
import {
  Stack,
  Typography,
  Card,
  Tooltip,
  Icon,
  IconButton,
  Alert,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "investira.react.components";
import { formats, validators } from "investira.sdk";

const Analise = (props) => {
  const { data } = props;
  return (
    <>
      <Stack
        direction="column"
        sx={{ gap: 1 }}
        component="section"
        flexGrow={1}
      >
        <Stack gap={1} flexGrow={1} direction={{ xs: "column", md: "row" }}>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell colSpan={2} align="center">
                    Ano
                  </TableCell>
                  <TableCell colSpan={2} align="center">
                    Mês
                  </TableCell>
                  <TableCell colSpan={2} align="center">
                    Dia
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell align="right">
                    <b>VaR</b>
                  </TableCell>
                  <TableCell>Paramétrico</TableCell>
                  <TableCell align="right">-907.817</TableCell>
                  <TableCell align="right">-2,22%</TableCell>
                  <TableCell align="right">-262.06</TableCell>
                  <TableCell align="right">-0,64%</TableCell>
                  <TableCell align="right">-57.187</TableCell>
                  <TableCell align="right">-0,14%</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>Histórico</TableCell>
                  <TableCell align="right">-907.817</TableCell>
                  <TableCell align="right">-2,22%</TableCell>
                  <TableCell align="right">-262.06</TableCell>
                  <TableCell align="right">-0,64%</TableCell>
                  <TableCell align="right">-57.187</TableCell>
                  <TableCell align="right">-0,14%</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>EWMA</TableCell>
                  <TableCell align="right">-907.817</TableCell>
                  <TableCell align="right">-2,22%</TableCell>
                  <TableCell align="right">-262.06</TableCell>
                  <TableCell align="right">-0,64%</TableCell>
                  <TableCell align="right">-57.187</TableCell>
                  <TableCell align="right">-0,14%</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">
                    <b>Beta</b>
                  </TableCell>
                  <TableCell>IBOVESPA</TableCell>
                  <TableCell align="right">-907.817</TableCell>
                  <TableCell align="right">-2,22%</TableCell>
                  <TableCell align="right">-262.06</TableCell>
                  <TableCell align="right">-0,64%</TableCell>
                  <TableCell align="right">-57.187</TableCell>
                  <TableCell align="right">-0,14%</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>IBRX 50</TableCell>
                  <TableCell align="right">-907.817</TableCell>
                  <TableCell align="right">-2,22%</TableCell>
                  <TableCell align="right">-262.06</TableCell>
                  <TableCell align="right">-0,64%</TableCell>
                  <TableCell align="right">-57.187</TableCell>
                  <TableCell align="right">-0,14%</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">
                    <b>Volatilidade</b>
                  </TableCell>
                  <TableCell>Normal</TableCell>
                  <TableCell align="right">-907.817</TableCell>
                  <TableCell align="right">-2,22%</TableCell>
                  <TableCell align="right">-262.06</TableCell>
                  <TableCell align="right">-0,64%</TableCell>
                  <TableCell align="right">-57.187</TableCell>
                  <TableCell align="right">-0,14%</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>EWMA</TableCell>
                  <TableCell align="right">-907.817</TableCell>
                  <TableCell align="right">-2,22%</TableCell>
                  <TableCell align="right">-262.06</TableCell>
                  <TableCell align="right">-0,64%</TableCell>
                  <TableCell align="right">-57.187</TableCell>
                  <TableCell align="right">-0,14%</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
      </Stack>
    </>
  );
};

export default Analise;
